import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '提交反馈'
    },  
    component: HomeView
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '自动订阅协议'
    },  
    component: () => import('../views/Agreement.vue')
  },
  {
    path: '/question',
    name: 'question',
    meta: {
      title: '猜你想问'
    },  
    component: () => import('../views/Question.vue')
  }
]

//以下代码解决路由地址重复点击的报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
